// Small form primitives shared by the Inventory admin page and its Phase 2
// panels (suppliers, goods inward, lots).

import React from "react";
import { Label } from "../ui/label";
import { toast } from "sonner";
import { inventoryErrorMessage } from "../../lib/inventory";

export const selectCls = "h-9 w-full rounded-md border border-input bg-background px-2 text-sm";

export function fail(e, fallback) {
  toast.error(inventoryErrorMessage(e, fallback));
}

export function Field({ label, children, testId }) {
  return (
    <div className="space-y-1" data-testid={testId}>
      <Label className="text-xs text-muted-foreground">{label}</Label>
      {children}
    </div>
  );
}

export function Select({ value, onChange, options, testId, placeholder }) {
  return (
    <select className={selectCls} value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testId}>
      {placeholder !== undefined && <option value="">{placeholder}</option>}
      {options.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  );
}
